/**
 * Utility for finding keyboard injector in document.
 */
export default class KeyboardInjectorFinder {
    /**
     * Finds KeyboardInjector in document.
     *
     * @returns Keyboard injector.
     */
    static findKeyboardInjectorElement() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!window.$ikeaKompisKeyboardInjectorTagNames) {
            return null;
        }
        return document.querySelector(window.$ikeaKompisKeyboardInjectorTagNames.join(','));
    }
}
//# sourceMappingURL=KeyboardInjectorFinder.js.map